import React, { Component }from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { UI_HEIGHT, BACKGROUND_COLOR } from '../Common/constants';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Table, Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';
import checkPermission from '../Common/permissions';
//import {buttonStyle} from '../Common/style'

class ScrapRecords extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

            rows: [],
            selectedRows: null,
            editedRows: [],
            filters: {},
            sortColumn: null,
            sortDirection: null,
            gourpOpen: false
        };

        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.props.fetchScrapRecords();
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once scrapRecords is ready, reset state.

    componentWillReceiveProps(nextProps) {
        const PT = nextProps.scrapRecords;
        if (nextProps.scrapRecords && nextProps.scrapRecords != this.props.scrapRecords) {
            this.setState({
                rows: nextProps.scrapRecords
            });
        }
    }

    handleResize(e) {
        this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton });
    }

    // Set scrapRecords being selected to be currentScrapRecord and navigate user to the edit page

    setCurrentScrapRecord(e) {
        e.preventDefault();
        const currentScrapRecord = this.state.selectedRows[0];
        this.props.selectScrapRecord(currentScrapRecord);
        this.context.router.push('/scrapRecords/'+currentScrapRecord.WarehouseScrapNum);
    }

    clickNew(e) {
        e.preventDefault();
        this.props.resetCurrentScrapRecord();
        this.context.router.push('/scrapRecords/new');
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
        if (this.props.isLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState(state);
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                this.setState({ filters: newFilters });
            }

            const onRowSelect = rows => {
                this.setState({ selectedRows: rows });
            }

            // Handle the editable function

            const handleRowUpdated = e => {
                // merge updated row with current row and rerender by setting state
                let rows = this.state.rows.slice(0);
                let editedRows = this.state.editedRows.slice(0);
                Object.assign(rows[e.rowIdx], e.updated);
                // if the element is already edited, remove the old one.
                editedRows.forEach((element, index) => {
                    if (element.Product_id === rows[e.rowIdx].Product_id)
                        editedRows.splice(index, 1)
                }, this);
                // push the row into the editedRows array
                editedRows.push(rows[e.rowIdx]);
                this.setState({
                    rows: rows,
                    editedRows: editedRows
                });
            }

            //Custom Formatter component
            const IsEnabledFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span className="label label-success"><Translate value="enabled" /></span>;
                    else return <span className="label label-danger"><Translate value="disable" /></span>;
                }
            });

            const DateFormatter = React.createClass({
                render() {
                    if (this.props.value) {
                      let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                      let date = new Date(this.props.value)
                      let index = dateMap.indexOf(date.toString().slice(4,3));
                      let localDate = index + date.toString().slice(8, 6);
                      return <span>{date.toString().slice(4, 15)}</span>;;
                    }
                    else return <span className="label label-danger">-</span>;
                }
            });

            const columns = [
              {
                  key: 'WarehouseScrapNum',
                  name: <Translate value="record_scrap_no" />,
                  resizable: true,
                  width: 155,
                  sortable: true,
                  filterable: true,
                  locked: true
              },
              {
                  key: 'CreateTime',
                  name: <Translate value="create_time" />,
                  resizable: true,
                  width: 110,
                  sortable: true,
                  filterable: true,
                  formatter: DateFormatter
              },
              {
                  key: 'PostingDate',
                  name: <Translate value="adjustment_date" />,
                  resizable: true,
                  width: 150,
                  sortable: true,
                  filterable: true,
                  formatter: DateFormatter
              },
              {
                  key: 'Modify_Username',
                  name: <Translate value="modifier" />,
                  resizable: true,
                  width: 110,
                  sortable: true,
                  filterable: true
              },
              {
                  key: 'Note',
                  name: <Translate value="note" />,
                  resizable: true,
                  width: 120,
                  sortable: true,
                  filterable: true
              },
              {
                  key: 'Completed',
                  name: <Translate value="completed" />,
                  resizable: true,
                  width: 110,
                  sortable: true,
                  filterable: true
              }
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="ScrapRecords-dataGrid1">
                    <ReactDataGrid
                        rowKey='WarehouseScrapNum'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowHeight={25}
                        minHeight={685}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        onRowUpdated={handleRowUpdated}
                        enableRowSelect='single'
                        onRowSelect={onRowSelect}
                        />
                </div></Col></Row>
            )
        }
    }

    render() {
        return (
            <ContentWrapper>
              <Breadcrumb>
                <Breadcrumb.Item>
                  <Translate value="warehouse_management" />
                </Breadcrumb.Item>
                <Breadcrumb.Item active="true">
                  <Translate value="inventory_scrap" />
                </Breadcrumb.Item>
              </Breadcrumb> {/* End Nav Trail */}
              <Grid fluid="true" id="inventory-scrap">
                <ButtonToolbar className="table-buttons">
                    {/* <Button href="/inventories"  bsStyle="success"  ><em className="fa fa-mail-reply"/></Button> */}
                    <Button bsStyle="success"  onClick={(e) => this.clickNew(e) }  disabled={!checkPermission("add_warehouse_scrap")} >
                        <em className="fa fa-plus marginRightStyle" /><Translate value="create" />
                    </Button>
                    <Button bsStyle="warning" disabled={!this.state.selectedRows || this.state.selectedRows.length != 1 || !checkPermission("change_warehouse_scrap")} onClick={(e) => this.setCurrentScrapRecord(e) }>
                        <em className="fa fa-plus marginRightStyle" /><Translate value="edit" />
                    </Button>
                    {/* <Button bsStyle="primary" >
                        <em className="fa fa-print marginRightStyle" /><Translate value="print" />
                    </Button>
                    <Button bsStyle="danger" >
                        <em className="fa fa-trash marginRightStyle" /><Translate value="delete" />
                    </Button> */}
                </ButtonToolbar>
                <Panel id="inventory-scrap-full-table">
                  { this.renderTable() }
                </Panel>
              </Grid>
            </ContentWrapper>
        );
    }
}



export default ScrapRecords;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/scrapRecords.jsx